const contact = {
    eyebrow: 'Get in touch',
    contact: "Let's build something",
    description:
        'Open to conversations about AI engineering roles, interesting problems, or collaborating on something worth shipping. I read every message.',
    getInTouch: 'Send me a message',
};

export default contact;
